// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZEHUysaHhSkFJrNA1G6F{width:290px}.C_JDQwZuv8013reakkJ6{border-top:1px var(--border-neutral-default)solid;padding:4px}.GPnAz1PSSEkrNYue0Mik,.Uz5oZObp8A788lzzdfrb{justify-content:center;align-items:center;padding:15px;display:flex}.RqIOusQMsco0EB6h8erj{height:100%;color:var(--content-primary-primary);text-overflow:ellipsis;padding:4px;font-size:13px;font-weight:400}.tXeVkaEEok8jX4kFkkeR{background:var(--background-primary-inverted-primary);border:none;border-radius:6px;outline:none;padding:12px}.zH4eQDeWjTM58vcBGvv6{border-bottom:1px solid var(--border-neutral-default)}.LcJYrqH1r8AkOnytBxAJ{background-color:var(--border-neutral-default);width:100%;height:1px;margin:4px 0}.dj7TRGa8AzmR9lVM3CRI{color:var(--gray-60);justify-content:center;align-items:center;padding:15px;display:flex}.K3noS29f6OMH1Z4kE6pn{padding:8.5px 12px;display:inline-block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ZEHUysaHhSkFJrNA1G6F`,
	"clear": `C_JDQwZuv8013reakkJ6`,
	"spinner": `GPnAz1PSSEkrNYue0Mik`,
	"epmtyList": `Uz5oZObp8A788lzzdfrb`,
	"list": `RqIOusQMsco0EB6h8erj`,
	"search": `tXeVkaEEok8jX4kFkkeR`,
	"searchWrap": `zH4eQDeWjTM58vcBGvv6`,
	"divider": `LcJYrqH1r8AkOnytBxAJ`,
	"emptyList": `dj7TRGa8AzmR9lVM3CRI`,
	"limitInfo": `K3noS29f6OMH1Z4kE6pn`
};
export default ___CSS_LOADER_EXPORT___;
